module.exports = __webpack_public_path__ + "img/rss.514c5c03.svg";